import { searchAPI } from "services/apis.service";


export class PublisherSearchService {
  #axios;

  constructor(axiosInstance) {
    this.#axios = axiosInstance;
  }

  async getPublisherToken(url) {
    try {
      const { data } = await this.#axios.post(
        searchAPI.getPublisherRefreshToken,
        {
          articleUrl: url,
        },
        {
          cache: false,
        }
      );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
